module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (13).27898389.jpg";